<template>
  <LoaderWrapper ref="dashboardLoader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">

              <div class="row">
                <div class="form-group col-sm-12">
                  <ul class="navbar-nav overflow-auto flex-row gap-4" >
                    <li v-for="(value, tab) in Tabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap" >
                      <a href="#" @click.prevent="selectTab(tab)" class="nav-link tab" :class="{'active': activeTabName === tab}">{{ helper.trans(`admin.tab.${tab}`) }}</a>
                    </li>
                  </ul>
                </div>
              </div>

              <LoaderWrapper ref="summaryLoader" class="h-100 mt-3">
                <div class="row">
                  <div v-for="account in summary" class="form-group col-sm-4">
                    <div class="row">
                      <AccountWidget show-icon hide-insurance :account="account"></AccountWidget>
                    </div>
                  </div>
                </div>
              </LoaderWrapper>


            </div>
          </div>

          <SystemAccounts v-if="activeTabName === Tabs.system"></SystemAccounts>
          <TraderAccounts v-else-if="activeTabName === Tabs.traders"></TraderAccounts>
          <UserAccounts v-else-if="activeTabName === Tabs.teamleads" :role="UserRole.TRADER_TEAM_LEAD"></UserAccounts>
          <MerchantStoreAccounts v-else-if="activeTabName === Tabs.merchants"></MerchantStoreAccounts>
          <UserAccounts v-else-if="activeTabName === Tabs.referrals" :role="UserRole.REFERRAL"></UserAccounts>

        </div>
      </div>
    </div>


    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed, onActivated} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import AccountDTO from "@/models/AccountDTO";
import {BPagination} from "bootstrap-vue-3";
import SystemAccounts from "@/components/SystemAccounts.vue";
import TraderAccounts from "@/components/TraderAccounts.vue";
import MerchantStoreAccounts from "@/components/MerchantStoreAccounts.vue";
import UserAccounts from "@/components/UserAccounts.vue";
import {UserRole} from "@/models/enum/UserRole";
import AccountWidget from "@/components/AccountWidget.vue";

const api = new APIClient();
const notification = useNotification()

enum Tabs {
  system = 'system', traders = 'traders', merchants = 'merchants', teamleads = 'teamleads', referrals = 'referrals'
}
export default defineComponent({
  components: {
    AccountWidget,
    UserAccounts,
    LoaderWrapper,
    ConfirmModal,
    CopyButton,
    BPagination,
    SystemAccounts,
    TraderAccounts,
    MerchantStoreAccounts
  },
  setup() {
    const store = useStore()
    const dashboardLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const summaryLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    const state = reactive({
      summary: [] as AccountDTO[],
      activeTabName: Tabs.system as Tabs
    });

    const selectTab = async (tab: Tabs) => {
      state.activeTabName = tab
      summaryLoader.value?.show()
      switch (tab) {
        case Tabs.traders:
          state.summary = await api.traderAccountsSummary();
          break;
        case Tabs.merchants:
          state.summary = await api.merchantStoreAccountsSummary();
          break;
        case Tabs.system:
          state.summary = await api.systemAccountsSummary();
          break;
        case Tabs.teamleads:
          state.summary = await api.userAccountsSummary({userRole: UserRole.TRADER_TEAM_LEAD});
          break;
        default:
          state.summary = [];
          break;
      }
      summaryLoader.value?.hide()
    }

    onMounted(() => {
      selectTab(Tabs.system)
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      dashboardLoader,
      summaryLoader,
      dateHelper,
      numberFormatter,
      confirmModal,
      helper,
      Tabs,
      selectTab,
      UserRole
    }
  }
})
</script>
